/* src/app/shared/gauge/gauge.component.scss */
.gauge {
  background-image: url(/assets/images/gauge.png);
  background-size: contain;
  background-repeat: no-repeat;
  width: 50vw;
  height: 50vw;
  text-align: center;
  color: white;
  margin: 5px;
  box-shadow: 0 0 4px black;
  border-radius: 50%;
}
.title {
  font-size: medium;
  padding-top: 13vw;
  padding-bottom: 0;
  margin: 0;
  text-shadow: 0 0 1px black;
}
.unit {
  margin: 0;
  padding-bottom: 6vw;
  font-size: small;
  padding-top: 0;
}
.subtitle {
  font-size: medium;
  padding: 0;
  margin: 0;
  width: 100%;
  padding-left: 6vw;
  padding-right: 6vw;
}
.index {
  font-size: small;
}
.index:first-child {
  margin-left: 11vw;
  position: absolute;
  margin-top: 30.5vw;
}
.index:nth-child(2) {
  margin-left: 11vw;
  position: absolute;
  margin-top: 14vw;
}
.index:nth-child(3) {
  width: 50.5vw;
  position: absolute;
  margin-top: 7.5vw;
  text-align: center;
}
.index:nth-child(4) {
  position: absolute;
  margin-top: 14vw;
  width: 39vw;
  text-align: right;
}
.index:nth-child(5) {
  position: absolute;
  margin-top: 30.5vw;
  position: absolute;
  width: 39vw;
  text-align: right;
}
.needle {
  position: absolute;
  background-image: url(/assets/images/needle.png);
  background-size: contain;
  background-repeat: no-repeat;
  width: 50vw;
  top: 0;
  margin: 5px;
  height: 50vw;
}
.redneedle {
  position: absolute;
  background-image: url(/assets/images/redneedle.png);
  background-size: contain;
  background-repeat: no-repeat;
  width: 50vw;
  top: 0;
  margin: 5px;
  height: 50vw;
}
/*# sourceMappingURL=gauge.component.css.map */
